import { DIALOGS } from './chat-screen-state';
import { Sentry } from '../../entry-setup/sentry';
import { firstServerError } from '../../util/api-errors';

export function deleteMessageActions() {
  return {
    deletingMessage: null,
    isDeletingMessage: false,
    deleteMessageError: null,

    openDeleteDialog(message) {
      this.deletingMessage = message;
      this.dialog = DIALOGS.DELETE_MESSAGE;
    },

    closeDeleteDialog() {
      this.deletingMessage = null;
      this.dialog = null;
    },

    // Opens the "delete for me" confirmation step; deletion is deferred until confirmed.
    openDeleteForMeConfirm() {
      this.dialog = DIALOGS.DELETE_MESSAGE_FOR_ME;
    },

    async submitDeleteMessage(scope) {
      if (!this.deletingMessage) return;

      this.isDeletingMessage = true;

      try {
        const response = await this.$api({
          url: `/chat/conversations/${this.activeConversationId}/messages/${this.deletingMessage.id}`,
          method: 'DELETE',
          query: { scope }
        });

        this.trackChat('message', 'delete', scope === 'for_everyone' ? 'for everyone' : 'for me');

        const updated = response.data.message;
        const index = this.activeConversation.messages.findIndex((m) => m.id === updated.id);
        if (index !== -1) {
          if (scope === 'for_everyone') {
            // Keep it in the list, now rendered as a "deleted" placeholder.
            this.activeConversation.messages.splice(index, 1, updated);
          } else {
            // "Delete for me" removes the message entirely for this user.
            this.activeConversation.messages.splice(index, 1);
          }
        }

        this.closeDeleteDialog();
      } catch (err) {
        // The most common failure is "already read" — the recipient read the
        // message in the window before the request landed, so it can no longer
        // be deleted for everyone. Surface the server's message as a toast and
        // close the dialog instead of leaving it stuck
        const messageId = this.deletingMessage?.id;
        this.closeDeleteDialog();

        const serverError = await firstServerError(err);
        if (!serverError) {
          // Unexpected failure (network, 5xx, etc.) — keep reporting to Sentry.
          Sentry.captureException(err, {
            extra: {
              message: 'Failed to delete message',
              conversationId: this.activeConversationId,
              messageId
            }
          });
        }

        this.showTransientError(
          'deleteMessageError',
          serverError || window.i18n?.t('chat.delete_message_dialog.delete_failed')
        );
      } finally {
        this.isDeletingMessage = false;
      }
    }
  };
}
